<template>
  <b-modal 
    id="create-material"
    ref="createMaterialRef"
    :hide-header="true"
    size="md">

    <form id="create-material-form">
      <h4 class="my-5">新建物料</h4>
      <div class="form-group row">
        <label class="col-4 col-form-label">物料名称</label>
        <div class="col-8">
          <input class="form-control input" type="text" placeholder="xx盒子/xx胶带等"
            name="material-name"
            v-validate="{ required: true, min: 1 }"
            :class="{'is-invalid': errors.has('material-name')}"
            v-model="material.material_name">
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label">物料ID</label>
        <div class="col-8">
          <input class="form-control input" type="text" placeholder="建议用拼音，创建后不可修改"
            name="mid" 
            :class="{'is-invalid': errors.has('mid')}"
            v-validate="{required: true, min: 1, max: 40}"
            v-model="material.mid">
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label">单位</label>
        <div class="col-8">
          <input class="form-control input" type="text" placeholder="便于记录用，无实际意义，如：斤/个/张。"
            name="unit"
            :class="{'is-invalid': errors.has('unit')}"
            v-validate="{ required: true, min: 1 }"
            v-model="material.unit">
        </div>
      </div>      
      
      <div class="form-group row">
        <label class="col-4 col-form-label">每次扣除</label>
        <div class="col-8">
          <input class="form-control input" type="text" placeholder="默认为1，无特殊原因不要修改"
            name="charge-amount" 
            :class="{'is-invalid': errors.has('charge-amount')}"
            v-validate="'min_value:1'"
            v-model="material.charge_amount">
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label">扣除方式</label>
        <div class="col-8">
           <select class="form-control"
            v-model="material.charge_on"
            :class="{'is-invalid': errors.has('charge-on')}"
            name="charge-on">
              <option v-for="(display, status) in chargeOnList" :value="status">{{display}}</option>
            </select>
        </div>
      </div>
    </form>
    <div slot="modal-footer" class="w-100">
      <button class="btn btn-primary float-right mx-5 btn-disabled" @click="submitMaterial" id="submit-create-material">提交</button>
      <button class="btn btn-secondary float-right" @click="$refs.createMaterialRef.hide();">取消</button>
   </div>
  </b-modal>
</template>

<script>
import MaterialMixin from '@/mixins/material'

function showMaterialModal () {
  this.$refs.createMaterialRef.show()
}

function submitMaterial () {
  // validate form
  this.$validator.validateAll().then((result) => {
    if (!result) {
      return
    }

    // 禁用按钮
    const button = document.getElementById('submit-create-material')
    if (button.disabled) {
      return
    } else {
      button.disabled = true
    }

    let form = document.getElementById('create-material-form')
    var object = {}
    new FormData(form).forEach(function (value, key) {
      object[key.replace(/-/g, '_')] = value
    })

    console.log(object)

    this.$http.post('/api/materials', object).then(response => {
      // 启用按钮，刷新页面
      setTimeout(() => {
        button.disabled = false
        this.$refs.createMaterialRef.hide()
        this.$emit('refresh')
      }, 1500)
    })
  })
}

export default {
  name: 'create-material',
  data () {
    return {
      'material': {
        mid: '',
        amount: 0,
        unit: '',
        charge_on: 'PER_BOOK',
        chage_amount: 1,
        material_name: ''
      }
    }
  },
  components: {},
  mixins: [MaterialMixin],
  methods: {
    showMaterialModal,
    submitMaterial
  }
}

</script>